import {Message} from 'element-ui'
import router from './app.routes'
import service from './services/common.service'
const _import=require('./core/utils/_import_production')
// const _import=require('./_import_production')
// const _import=require('./core/_import_production')
import mutations from './core/store/mutations';
const md5Base64 = require('md5-base64');
// let getRouter
let components = {};
const getComponents = function (routes) {
    routes.forEach(item => {
        if(item.component && item.name){
            components[item.name] = item.component;
        }
        if(item.children){
            getComponents(item.children);
        }
    });
};

const encode = function ({name, query, meta, path}) {
    const isMultiPage = typeof meta.isMultiPage === 'boolean' ? meta.isMultiPage : true;
    if(isMultiPage){
        let q = Object.assign({},query);
        if(q['_']){
            delete q['_'];
        }
        return md5Base64(name + JSON.stringify(q));
    } else {
        return md5Base64(path);
    }

};


const getRoutes = function (routes) {
    routes.forEach(item => {

        if(item.component && item.name){
            item.props = true;
            item.meta = Object.assign({},item.component.config||{},item.meta||{});
            item.component.name = item.component.name || item.name;
        }

        if(item.children){
            getRoutes(item.children);
        }
    });
    return routes;
};

export const getComponent = function (name) {
    return components[name];
};
var getRouter
router.beforeEach((to,from,next)=>{
    console.log("执行promission");
    // console.log(to,'to1');
    if (!getRouter){
        if (!getObjArr('wedof-itsm__router')){
            let user_id=window.localStorage.getItem('userid')
            service.getAuth({app_name:'itsm',user_id}).then(res=>{
                getRouter=[...res.route_data]
                // console.log(getRouter,"在promission里获取动态路由");
                saveObjArr('wedof-itsm__router',getRouter)
                routerGo(to,next)
            })
        } else{
            // console.log("本地有local存储，获取动态路由");
            getRouter=getObjArr('wedof-itsm__router')
            routerGo(to,next)
        }
    } else{
        // console.log("走next");
        // console.log(from)
        // console.log(getRouter);
        //当权限范围变大时，点击新显示出来的目录菜单，执行此操作，刷新页面
        if(to.path=='/'&&to.name){
            // Message.error('发现新页面')
            location.reload()
        }

        //当本地localStorage为空时（没有router和userid），从登录页点击登陆，执行此操作刷新页面
        if(to.path=='/index'&&!to.name&&from.path=='/login'){
            // Message.error('发现新页面')
            location.href='/'
            // location.reload()
        }
        //在这里判断to的路由是否在路由表中，不在的话则不跳转
        let path= to.path
        let pathfrom=from.path
        // let routeTable=getRouter
        // let routeTable=getObjArr('router')
        //默认从localStorage获取最新的router，如果没有（退出登录时会清空localStorage）则取路由对象里的路由表
        // console.log(getObjArr('wedof-itsm__router'));
        // console.log(getRouter);
        let routeTable=getObjArr('wedof-itsm__router')||getRouter
        // console.log(routeTable);
        let yes=isInRoute(path,routeTable)    //判断to的路径在不在路由表里
        let yesfrom=isInRoute(pathfrom,routeTable)  //判断from的路径在不在路由表里
        // console.log(yes);
        // console.log(yesfrom);
        if(!yes&&yesfrom){  //当to的路径不存在于路由表且from的路径存在路由表时进行的操作
            // console.log('执行跳回');
            Message.error('无法访问该页面，页面不存在或权限不足')
            if (from.path!='/'&&from.name){
                next({path:from.path})
            }
            // next({path:from.path})
        }
        if (!yes&&!yesfrom){//这是当减少权限且地址栏参数为减少的那个路由权限时，刷新页面，
            //to和from都不存在于路由表里， 跳转到'/'
            //防止出现死循环
            next('/')
        }

        if (to.name && to.meta.isModal) {
            // console.log('next-false');
            //需要注意 vuex只监听已经存在的属性，应全部提前定义好
            /*
            Mutation 需遵守 Vue 的响应规则
            既然 Vuex 的 store 中的状态是响应式的，那么当我们变更状态时，监视状态的 Vue 组件也会自动更新。这也意味着 Vuex 中的 mutation 也需要与使用 Vue 一样遵守一些注意事项:

            最好提前在你的 store 中初始化好所有所需属性。

            当需要在对象上添加新属性时，你应该

            使用 Vue.set(obj, 'newProp', 123), 或者

            以新对象替换老对象。例如，利用 stage-3 的对象展开运算符我们可以这样写:

            state.obj = { ...state.obj, newProp: 123 }

            https://vuex.vuejs.org/zh-cn/mutations.html
             */
            // console.log('走弹窗');
            if(!to.meta.title){
                throw new Error(`在modal模式下，请在 Component (${to.name}) config中设置title`);
            }
            // console.log(router.app.$store);
            router.app.$store.commit(mutations.MODAL_PUSH_PAGE, {
                component: to.name, //component,
                state: to,
                ...to.meta,
                visible: true
            });
            next(false);
        } else {
            // console.log(to);
            const keepAlive = to.query['_'] ? true : false;
            if(!to.query['_']){
                to.query['_'] = encode(to);
            }
            // Vue.nextTick(function () {//
            try {
                // console.log(router);
                // console.log(router.app.$store.state);
                // console.log(router.app.$store.state.tabView.isEnabled);
                if(to.name !== 'login' && !!to.name && router.app.$store.state.tabView.isEnabled){
                    // console.log("执行1");
                    const pages = router.app.$store.state.tabView.pages;
                    const idx = pages.findIndex(item => item.query['_'] === to.query['_']);
                    if(idx > -1){
                        router.app.$store.commit(mutations.TAB_VIEW_PUSH, {
                            ...pages[idx],
                            keepAlive
                        });
                    } else {
                        router.app.$store.commit(mutations.TAB_VIEW_PUSH, {
                            fullPath: to.fullPath,
                            hash: to.hash,
                            meta: to.meta,
                            name: to.name,
                            params: to.params,
                            path: to.path,
                            query: to.query,
                            keepAlive,
                            title: null
                        });
                    }

                }else{
                    // console.log("执行2");
                }
            }catch (e){
                // console.log(e.message)
            }
            try{
                // console.log("执行set面包屑");
                router.app.$store.commit(mutations.SET_BREADCRUMB, to.meta.breadcrumb || [to.meta.title] || []);
            }catch (e){
                console.error(e.message)
            }
            next();
        }
    }
})
function isInRoute(path,Arr){
    let inRoute
    // for(i=0;i<Arr.length;i++){
    //     if(Arr[i].path==path){
    //         console.log(Arr[i]);
    //         inRoute=true
    //     }else if(Arr[i].children&&Arr[i].children.length){
    //         console.log(path);
    //         console.log(Arr[i].children);
    //         inRoute=isInRoute(path,Arr[i].children)
    //     }
    // }
    try {
        Arr.forEach(item=>{
            if(item.path==path){
                // console.log(item);
                inRoute=true
                throw '存在此路由路径'
            }else if(item.children&&item.children.length){
                // console.log(path);
                // console.log(item.children);
                inRoute=isInRoute(path,item.children)
            }
        })
    }catch (e) {
        console.log(e);
    }

    return inRoute
}
function goCorrectRoute(to,next) {
    // console.log('正确跳转');
    next({ ...to, replace: true })
}
async function routerGo(to, next) {
    // console.log("执行routerGo");
    // console.log(to,'to2');
    getRouter = await filterAsyncRouter(getRouter) //过滤路由
    await getComponents(getRouter);
    await getRoutes(getRouter)
    router.addRoutes(getRouter) //动态添加路由
    // global.antRouter = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
    next({ ...to, replace: true })
}
function saveObjArr(name, data) { //localStorage 存储数组对象的方法
    localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
    return JSON.parse(window.localStorage.getItem(name));

}
function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) {
            if (route.component){
                // console.log(_import.function1(route.component));
                // route.component=require(_import.function1(route.component)).default
                // route.component=_import(route.component)
                route.component=_import.function1(route.component).default
                // console.log(route.component,'component转换成功了吗');
            }
            if (route.children&&route.children.length){
                route.children=filterAsyncRouter(route.children)
            }
            return true
        }
    })
    return accessedRouters
}
